/* eslint-disable */
import React from 'react'
import styled from '@emotion/styled'


const StyledSection = styled('section')`
  flex-grow: 1;

  @media (min-width: 769px) {
    margin-right: 20px;
  }

  p {
    font-size: 14px;
    font-family: ${({ theme }) => theme.fonts.soehneBuch};
    margin-top: 0;
  }

  h2 {
    font-size: 18px;
    margin-top: 0;
    margin-bottom: 0;
    @media (min-width: 768px) {
      margin-bottom: 8px;
    }
  }
`

const ContentBody = ({ children, ...rest }) => (
  <StyledSection {...rest}>{children}</StyledSection>
)

ContentBody.displayName = 'ContentBody'

export default ContentBody
